import { render, staticRenderFns } from "./priceBreakDown.vue?vue&type=template&id=779cbd2f&scoped=true&"
import script from "./priceBreakDown.vue?vue&type=script&lang=js&"
export * from "./priceBreakDown.vue?vue&type=script&lang=js&"
import style0 from "./priceBreakDown.vue?vue&type=style&index=0&id=779cbd2f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779cbd2f",
  null
  
)

export default component.exports